/** Where the browser's single GraphQL subscription stream lives, shared by client and server. */
export const GRAPHQL_STREAM_ENDPOINT = '/api/graphql/stream';
